<div class="flex h-full flex-col">
  <!-- Loading spinner -->
  @if (loading()) {
    <div class="flex h-32 items-center justify-center">
      <mat-spinner diameter="40" />
    </div>
  } @else if (data().length === 0) {
    <!-- Empty state -->
    <div class="flex h-32 flex-col items-center justify-center text-gray-500">
      <mat-icon class="mb-2 text-4xl">folder_open</mat-icon>
      <span>{{ 'routing.SUB_ROUTE_PARTNERS.GROUPED.EMPTY' | t }}</span>
    </div>
  } @else {
    <!-- Table -->
    <div class="flex-1 overflow-auto">
      <table mat-table [dataSource]="data()" multiTemplateDataRows class="w-full">
        <!-- Expand Column -->
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef class="!w-12"></th>
          <td mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              (click)="onRowExpand(row); $event.stopPropagation()"
              [matTooltip]="
                isExpanded(row)
                  ? ('routing.SUB_ROUTE_PARTNERS.GROUPED.COLLAPSE_TOOLTIP' | t)
                  : ('routing.SUB_ROUTE_PARTNERS.GROUPED.EXPAND_TOOLTIP' | t)
              "
            >
              <mat-icon>{{ isExpanded(row) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ 'GENERAL.NAME' | t }}</th>
          <td mat-cell *matCellDef="let row" class="font-medium">
            {{ row.name }}
          </td>
        </ng-container>

        <!-- Code Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>{{ 'GENERAL.CODE' | t }}</th>
          <td mat-cell *matCellDef="let row" class="text-gray-600">
            {{ row.code }}
          </td>
        </ng-container>

        <!-- Count Column -->
        <ng-container matColumnDef="count">
          <th mat-header-cell *matHeaderCellDef class="!text-right">{{ 'routing.SUB_ROUTE_PARTNERS.GROUPED.COL_COUNT' | t }}</th>
          <td mat-cell *matCellDef="let row" class="!text-right">
            <span
              class="inline-flex min-w-[2rem] items-center justify-center rounded-full bg-purple-100 px-2 py-0.5 text-sm font-semibold text-purple-800"
            >
              {{ row.totalBusinessPartners }}
            </span>
          </td>
        </ng-container>

        <!-- Expanded Content Column -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
            @if (isExpanded(row)) {
              <div class="bg-gray-50 p-4">
                @if (getExpandedData(row._id); as expandedData) {
                  @if (expandedData.loading) {
                    <div class="flex items-center justify-center py-4">
                      <mat-spinner diameter="24" />
                      <span class="ml-2 text-gray-500">{{ 'routing.SUB_ROUTE_PARTNERS.GROUPED.LOADING_PARTNERS' | t }}</span>
                    </div>
                  } @else if (expandedData.partners.length === 0) {
                    <div class="py-4 text-center text-gray-500">
                      {{ 'routing.SUB_ROUTE_PARTNERS.GROUPED.EMPTY_GROUP_PARTNERS' | t }}
                    </div>
                  } @else {
                    <!-- SmartGrid con partners -->
                    <app-smart-grid
                      [data]="expandedData.partners"
                      [columnDefs]="expandedColDefs"
                      [config]="expandedGridConfig"
                    />
                    <!-- Expanded paginator -->
                    @if (expandedData.totalItems > 10) {
                      <mat-paginator
                        class="mt-2"
                        [length]="expandedData.totalItems"
                        [pageSize]="expandedData.pageSize"
                        [pageIndex]="expandedData.currentPage - 1"
                        [pageSizeOptions]="[10, 25, 50]"
                        (page)="onExpandedPageChange(row, $event)"
                      />
                    }
                  }
                }
              </div>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="cursor-pointer transition-colors hover:bg-gray-50"
          [class.bg-purple-50]="isExpanded(row)"
          (click)="onRowExpand(row)"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="!h-0"></tr>
      </table>
    </div>

    <!-- Paginator -->
    <mat-paginator
      class="border-t border-gray-200"
      [length]="totalItems()"
      [pageSize]="pagination().limitPerPage"
      [pageIndex]="pagination().currentPage - 1"
      [pageSizeOptions]="[25, 50, 100]"
      (page)="onPageChange($event)"
      showFirstLastButtons
    />
  }
</div>
